// Returns an object constructed from the list of entries, converting any values for
// keys that appear multiple times into an array.
export function fromMultiEntries<ValueType>(
  entries: IterableIterator<[string, ValueType]>,
): Record<string, ValueType | ValueType[]> {
  return Array.from(entries).reduce((object, [key, value]) => {
    if (!object[key]) object[key] = value;
    else if (Array.isArray(object[key])) object[key].push(value);
    else object[key] = [object[key], value];
    return object;
  }, {});
}

// Freezes an object, and all of its properties, so they cannot be edited
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze#what_is_shallow_freeze
export function deepFreeze<T extends object>(object: T): Readonly<T> {
  // Retrieve the property names defined on object
  const propNames = Reflect.ownKeys(object);

  // Freeze properties before freezing self
  for (const name of propNames) {
    const value = object[name];

    if ((value && typeof value === 'object') || typeof value === 'function') {
      deepFreeze(value);
    }
  }

  return Object.freeze(object);
}
